<h1 mat-dialog-title>Neuen Benutzer Tierarzt anlegen</h1>
<form [formGroup]="newUserFormGroup" (ngSubmit)="safeAndCloseDialog()">
    <mat-dialog-content>
        <h5>Allgemeine Angaben</h5>
        <mat-form-field style="width: 100%">
            <mat-label>Titel</mat-label>
            <input placeholder="Titel" matInput formControlName="titel" />
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Vorname</mat-label>
            <input placeholder="Vorname" matInput formControlName="vorname" required />
            <mat-error *ngIf="newUserFormGroup.get('vorname').invalid">Bitte Vornamen eintragen! </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Nachname</mat-label>
            <input placeholder="Nachname" matInput formControlName="nachname" />
            <mat-error *ngIf="newUserFormGroup.get('nachname').invalid">Bitte Nachnamen eintragen! </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Straße</mat-label>
            <input placeholder="Straße" matInput formControlName="strasse" required />
            <mat-error *ngIf="newUserFormGroup.get('strasse').invalid">Bitte Straße eintragen! </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>PLZ</mat-label>
            <input placeholder="Postleitzahl" matInput formControlName="plz" required />
            <mat-error *ngIf="newUserFormGroup.get('plz').invalid">Bitte Postleitzahl eintragen! </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Ort</mat-label>
            <input matInput formControlName="ort" required />
            <mat-error *ngIf="newUserFormGroup.get('ort').invalid">Bitte Ort eintragen! </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Mobiltelefon</mat-label>
            <input matInput formControlName="mobil" />
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Festnetz</mat-label>
            <input matInput formControlName="festnetz" />
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>E-Mail Adresse</mat-label>
            <input placeholder="E-Mail Adresse" matInput formControlName="email" required />
            <mat-error *ngIf="newUserFormGroup.get('email').invalid">Ungültige E-Mail Adresse </mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%; margin-bottom: 12px">
            <mat-label>Passwort</mat-label>
            <input matInput type="text" formControlName="password" />
            <mat-hint
                >Passwort muss mindestens 8 Zeichen lang sein und mindestens ein Gro&szlig;buchstaben, ein
                Kleinbuchstaben und eine Ziffer beinhalten!
            </mat-hint>
        </mat-form-field>

        <div style="width: 100%; margin-top: 36px">
            <mat-checkbox [formControl]="sendePasswortAnEmailCtrl"
                ><span style="white-space: normal; width: 80%"
                    >Soll das Passwort an die oben genannte E-Mail Adresse
                    <strong>{{ newUserFormGroup.get("email").value }}</strong> gesendet werden?</span
                >
            </mat-checkbox>
        </div>

        <mat-divider></mat-divider>

        <h5>Tierarzt</h5>
        <mat-form-field style="width: 100%">
            <mat-label>Tierarztgruppen</mat-label>
            <mat-select multiple formControlName="tierarztgruppen" required>
                <mat-option *ngFor="let tg of tierarztgruppen" [value]="tg">{{ tg.bezeichnung }} </mat-option>
            </mat-select>
            <mat-error *ngIf="newUserFormGroup.get('tierarztgruppen').invalid"
                >Bitte Tierarztgruppen eintragen!
            </mat-error>
        </mat-form-field>

        <mat-form-field style="margin-right: 12px">
            <mat-label>Kennzeichen</mat-label>
            <input matInput type="text" [formControl]="kennzeichenCtrl" />
        </mat-form-field>

        <mat-form-field style="margin-right: 12px">
            <mat-label>Tierarztnummer</mat-label>
            <input matInput type="number" [formControl]="vetNumberCtrl" />
        </mat-form-field>

        <mat-form-field style="margin-right: 12px">
            <mat-label>QS Alias</mat-label>
            <input matInput type="text" [formControl]="qsAliasCtrl" />
        </mat-form-field>

        <mat-form-field style="margin-right: 12px">
            <mat-label>N&auml;chste Abgabebelegnr</mat-label>
            <input matInput type="number" [formControl]="abgabebelegNrCtrl" />
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancelClick()"> Abbrechen </button>
        <button mat-flat-button color="accent" type="submit" [disabled]="isDisabled()"> Anlegen </button>
    </mat-dialog-actions> </form
>`
